import { inject, Injectable } from '@angular/core';
import { SAVE_SERVICE } from '@core/saves/saves.interface';
import { clamp } from '@shared/math.utils';

@Injectable({
  providedIn: 'root',
})
export class Wk8ReadService {
  readonly #saveService = inject(SAVE_SERVICE);

  public async getReadSpeed(): Promise<number> {
    const save = await this.#saveService.load();
    const speed = save.readSpeed.speed;
    console.info(`Read speed: ${speed}`);
    return speed;
  }

  public async updateReadSpeed(success: boolean): Promise<number> {
    const save = await this.#saveService.load();
    const n = save.readSpeed.n;
    const speed = save.readSpeed.speed;

    const adjustmentFactor = Math.max(0.1, 1 / Math.max(n, 1));
    const target = clamp(success ? speed - 25 : speed + 100, 50, 4000);
    const newSpeed = Math.round(speed + adjustmentFactor * (target - speed));
    await this.#saveService.save({ readSpeed: { n: n + 1, speed: newSpeed } });
    return newSpeed;
  }
}
